import { AlertNotificationConfig } from "object-models/shared/alertNotification-config.model";

export default class NotificationHelper {
  private static notificationDispatcher?: (config: AlertNotificationConfig) => void;

  static setNotificationDispatcher(
    dispatcher?: (config: AlertNotificationConfig) => void
  ) {
    NotificationHelper.notificationDispatcher = dispatcher;
  }

  static notify(config: AlertNotificationConfig) {
    if (NotificationHelper.notificationDispatcher) {
      NotificationHelper.notificationDispatcher(config);
      return;
    }

    if (process.env.NODE_ENV !== "production") {
      console.warn(
        "NotificationHelper.notify called before dispatcher registration. Notification was dropped.",
        config
      );
    }
  }

  static notifySuccess(message: string) {
    NotificationHelper.notify(NotificationHelper.successNotification(message));
  }

  static notifyWarning(message: string) {
    NotificationHelper.notify(NotificationHelper.warningNotification(message));
  }

  static notifyError(message: string) {
    NotificationHelper.notify(NotificationHelper.errorNotification(message));
  }

  static notifyInfo(message: string) {
    NotificationHelper.notify(NotificationHelper.infoNotification(message));
  }

  static successNotification(message: string): AlertNotificationConfig {
    const successNotification: AlertNotificationConfig = {
      message: message,
      open: true,
      severity: "success",
    };
    return successNotification;
  }
  static warningNotification(message: string): AlertNotificationConfig {
    const warningNotification: AlertNotificationConfig = {
      message: message,
      open: true,
      severity: "warning",
    };
    return warningNotification;
  }
  static errorNotification(message: string): AlertNotificationConfig {
    const errorNotification: AlertNotificationConfig = {
      message: message,
      open: true,
      severity: "error",
    };
    return errorNotification;
  }
  static infoNotification(message: string): AlertNotificationConfig {
    const infoNotification: AlertNotificationConfig = {
      message: message,
      open: true,
      severity: "info",
    };
    return infoNotification;
  }
}
